














































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography, TextField, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import SuccessFeedback from '@/components/icons/SuccessFeedback.vue';
import MailIcon from '@/components/icons/Mail.vue';
import CloseIcon from '@/components/icons/CloseModal.vue';
import segmentIo from '@/utils/segment.io';
import flagKeys from '@/constants/flagKeys';
import { isExternalOauthSessionOnline } from '@/router/router-utils';

@Component({
  components: {
    Surface,
    Typography,
    TextField,
    Picture,
    FilledButton,
    SuccessFeedback,
    MailIcon,
    CloseIcon
  }
})
export default class NewCountryNotifyModal extends Vue {
  @Prop() buttonLabel!: string;
  @Prop() hasFooterText!: boolean;
  @Prop() onConfirm!: () => void;
  @Prop() onClose!: () => void;
  @Prop() email?: string;
  @Prop() countryName?: string;

  loading: boolean = false;

  get name() {
    const { firstName } = this.$store.getters[
      'businessOnboarding/getAccountFormData'
    ];

    if (firstName) {
      return firstName;
    }
    if (this.$store.getters['manager/getExtraInfo'])
      return this.$store.getters['manager/getExtraInfo'].fullname.split(' ')[0];

    return '';
  }

  get mail() {
    if (this.email) return this.email;

    const { email } = this.$store.getters[
      'businessOnboarding/getAccountFormData'
    ];

    if (email) {
      return email;
    }

    return this.$store.getters['manager/getExtraInfo'].mail;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isNewDirectLinkSignup() {
    return !isExternalOauthSessionOnline();
  }

  created() {
    segmentIo.modal(
      `${
        this.isNewDirectLinkSignup ? 'BFR' : 'NPO'
      } Sign Up/Country Availability`,
      {
        'Country Name': this.countryName,
        'Direct Link': !!this.isNewDirectLinkSignup
      }
    );
  }
}
